/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import template from './dvsn-form-builder-form-create.html.twig';

const { Component } = Shopware;

Component.extend('dvsn-form-builder-form-create', 'dvsn-form-builder-form-detail', {
    template,

    computed: {
        tabs() {
            return [{
                'name': 'base',
                'label': this.$t('dvsn-form-builder-form.detail.tabs.base'),
                'disabled': false
            }, {
                'name': 'elements',
                'label': this.$t('dvsn-form-builder-form.detail.tabs.elements'),
                'disabled': true
            }];
        }
    },

    methods: {
        getForm() {
            Shopware.Store.get('context').setApiLanguageId(Shopware.Context.api.systemLanguageId);

            this.form = this.repository.create(Shopware.Context.api);

            this.form.status = true;
            this.form.name = '';
            this.form.emailStatus = false;
            this.form.emailRecipient = null;
            this.form.responseType = 'alert-success';
            this.form.responseMessage = null;
        },

        async onClickSave() {
            this.forceValidValues();

            if (this.validateValues() === false) {
                this.isSaveSuccessful = false;
                return;
            }

            this.isLoading = true;

            try {
                await this.repository.save(this.form, Shopware.Context.api);

                this.$router.push({ name: 'dvsn.form.builder.form.detail', params: { id: this.form.id } });

                this.createNotificationSuccess({
                    title: this.$t('dvsn-form-builder-form.detail.success-title'),
                    message: this.$t('dvsn-form-builder-form.detail.success-message')
                });
            } catch (error) {
                this.dvsnFormBuilderErrorHandlerService.handleApiError(
                    this, error, {
                        message: this.$t('dvsn-form-builder-form.detail.error-title')
                    }
                );
            } finally {
                this.isLoading = false;
            }
        }
    }
});
